import React from "react";

import Icon from "../Icon";

const TEXT_CLOZE_RE = /\{\{([^{}]*)\}\}/;

function plainSentence(text) {
  if(!text) return "";
  return text.replace(TEXT_CLOZE_RE, "$1");
}

function speakText(text, targetLanguageIso) {
  if(!text || !targetLanguageIso || !window.clozemaster) return;
  const voices = window.clozemaster.getSystemTtsVoices(targetLanguageIso);
  if(!voices || !voices.length) return;
  const u = new SpeechSynthesisUtterance(text);
  u.voice = voices[0];
  u.lang = voices[0].lang;
  window.speechSynthesis.cancel();
  window.speechSynthesis.speak(u);
}

export default function EntryDropdown({ entry, onDelete, onExplain, onEdit, onImport, targetLanguageIso, word }) {
  const hasTts = typeof window !== "undefined" && window.speechSynthesis && targetLanguageIso;

  return (
    <div className="btn-group">
      <button
        aria-expanded="false"
        aria-haspopup="true"
        className="btn btn-default btn-xs dropdown-toggle"
        data-toggle="dropdown"
        type="button"
      >
        <span className="caret"></span>
      </button>
      <ul className="dropdown-menu dropdown-menu-right">
        {hasTts && word && (
          <li><a href="#" onClick={(e) => { e.preventDefault(); speakText(word, targetLanguageIso); }}><Icon name="volume-up" /> Listen to word</a></li>
        )}
        {hasTts && entry.sentence && (
          <li><a href="#" onClick={(e) => { e.preventDefault(); speakText(plainSentence(entry.sentence), targetLanguageIso); }}><Icon name="volume-up" /> Listen to sentence</a></li>
        )}
        {hasTts && (word || entry.sentence) && <li role="separator" className="divider"></li>}
        {entry.explanationUrl && (
          <li><a href="#" onClick={(e) => { e.preventDefault(); onExplain(); }}>Explain</a></li>
        )}
        <li><a href="#" onClick={(e) => { e.preventDefault(); onEdit(); }}>Edit</a></li>
        <li><a href="#" onClick={(e) => { e.preventDefault(); onImport(); }}>Import this entry</a></li>
        <li role="separator" className="divider"></li>
        <li><a className="text-danger" href="#" onClick={(e) => { e.preventDefault(); onDelete(); }}>Delete</a></li>
      </ul>
    </div>
  );
}
